import React from "react";
import FeedbackForm from "../components/forms/FeedbackForm";

export default function FeedbackPage() {
    return (
        <div className="min-h-screen bg-slate-100 py-12 px-4">
            <div className="mx-auto max-w-3xl">
                <div className="rounded-3xl bg-white shadow-xl border border-slate-200 p-8">
                    <div className="text-center mb-10">
                        <h1 className="text-4xl font-black text-slate-900">
                            Feedback
                        </h1>

                        <p className="mt-4 text-lg text-slate-600">
                            We value your opinion and continuously improve our
                            Secure Transparent Data Exchange platform.
                        </p>
                    </div>

                    <div className="mb-8 rounded-2xl border border-blue-200 bg-blue-50 p-5">
                        <h2 className="font-bold text-blue-900 text-lg">
                            Your feedback matters
                        </h2>

                        <p className="mt-2 text-blue-800">
                            You may submit feedback either anonymously or while
                            signed in. If you are logged in, your account can be
                            linked automatically to your feedback to help us
                            respond more effectively.
                        </p>
                    </div>

                    <FeedbackForm />
                </div>
            </div>
        </div>
    );
}